module.exports = __webpack_public_path__ + "img/pen-solid.367468c7.svg";